import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { map, take } from 'rxjs/operators';
import { Router } from '@angular/router';

export const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated$.pipe(
    take(1),
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        authService.loginWithRedirect({
          appState: { target: router.url },
        });
        return false;
      }
      return true;
    }),
  );
};
